/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetGipMetadataParamsForOrderQueryResponse, AuditReportsGetGipMetadataParamsForOrderQueryParams, AuditReportsGetGipMetadataParamsForOrder401, AuditReportsGetGipMetadataParamsForOrder403 } from "../models/AuditReportsGetGipMetadataParamsForOrder";

export function getAuditReportsGetGipMetadataParamsForOrderUrl() {
  const res = { method: 'GET', url: `/audit-reports/v1/reports/gip/metadata/params-for-order` as const }
  return res
}

/**
 * @summary Return GIP report params for order id(s)
 * {@link /audit-reports/v1/reports/gip/metadata/params-for-order}
 */
export async function auditReportsGetGipMetadataParamsForOrder(params: AuditReportsGetGipMetadataParamsForOrderQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsGetGipMetadataParamsForOrderQueryResponse, ResponseErrorConfig<AuditReportsGetGipMetadataParamsForOrder401 | AuditReportsGetGipMetadataParamsForOrder403>, unknown>({ method : "GET", url : getAuditReportsGetGipMetadataParamsForOrderUrl().url.toString(), params, ... requestConfig })
  return res.data
}